import { defineComponent as _defineComponent } from 'vue'
import {computed, ComputedRef, onMounted, onUnmounted, reactive, watch} from "vue";
  import MonthPicker from "@/components/MonthPicker.vue";
  import Order from "@/model/Order";
  import SwitchView from "@/components/SwitchView.vue";
  import OrderPerDiemsDate from "./OrderPerDiemsDate.vue";
  import {OrderPerDiemDateEmployeeEntry, OrderPerDiemDateEntry, OrderPerDiemMonth} from "@/service/OrderPerDiemMonth";
  import moment from "moment/moment";
  import {date, orderId} from "@/RouterUtils";
  import {isValidDate, isValidMonth} from "@/DateUtils";
  import router from "@/router";
  import eventBus from "@/eventbus";
  import {MessageTypes} from "@/components/message-types";
  import OrderService from "@/service/OrderService";
  import {AxiosResponse} from "axios";

  declare interface BreadCrumb {
    text: string,
    disabled: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderPerDiems',
  props: {
    order: {
      type: Order,
      default: () => null
    }
  },
  setup(__props) {

const props = __props

  

  const initialState = {
    perDiemOrderDates: new Array<OrderPerDiemDateEntry>(),
    yearMonth: ""
  };

  const state = reactive({...initialState});

  const perDiemUpdateCallback = () => {
    loadPerDiems(currentMonth.value);
  };

  onMounted(() => {
    eventBus.$on(MessageTypes.PERDIEM_UPDATED, perDiemUpdateCallback);

    loadPerDiems(currentMonth.value);
  });

  onUnmounted(() => {
    eventBus.$off(MessageTypes.PERDIEM_UPDATED, perDiemUpdateCallback);
  });

  function loadPerDiems(yearMonth: string | null) {
    if (yearMonth) {
      OrderService.findPerDiemsByMonth(orderId.value, yearMonth)
        .then((response: AxiosResponse<OrderPerDiemMonth>) => {
          state.perDiemOrderDates = response.data.dates;
          state.yearMonth = yearMonth;
        });
    } else {
      OrderService.findRecentPerDiems(orderId.value)
        .then((response: AxiosResponse<OrderPerDiemMonth>) => {
          state.perDiemOrderDates = response.data.dates;

          //  Update the current yearMonth to the one of the most recent entries
          if (state.perDiemOrderDates.length > 0) {
            state.yearMonth = moment(state.perDiemOrderDates[0].date, "YYYY-MM-DD").format("YYYY-MM");
          } else {
            if (!props.order.validTo) {
              state.yearMonth = moment().format("YYYY-MM");
            } else {
              if (moment().isAfter(moment(props.order.validTo))) {
                state.yearMonth = moment(props.order.validTo).format("YYYY-MM");
              } else {
                state.yearMonth = moment().format("YYYY-MM");
              }
            }
          }

        });
    }
  }

  const breadcrumbs: ComputedRef<Array<BreadCrumb>> = computed(() => {
    const breadcrumbs = [];
    breadcrumbs.push({
      text: moment(currentMonth.value, "YYYY-MM").format("MMMM YYYY"),
      disabled: !isDayView.value,
      exact: true,
      to: {path: router.app.$route.path, query: {view: "list", date: currentMonth.value}}
    });
    if (isDayView.value) {
      breadcrumbs.push({
        text: moment(date.value).format("DD. MMMM YYYY"),
        disabled: true
      });
    }

    return breadcrumbs;
  });

  const currentDateEntry: ComputedRef<OrderPerDiemDateEntry> = computed(() => {
    const find = state.perDiemOrderDates.find(dateEntry => dateEntry.date === date.value);
    if (find) {
      return find;
    } else {
      const entry = new OrderPerDiemDateEntry();
      entry.date = date.value ? date.value : moment().format("YYYY-MM-DD");
      entry.employees = new Array<OrderPerDiemDateEmployeeEntry>();

      return entry;
    }
  });

  const currentMonth: ComputedRef<string | null> = computed(() => {
    if (isValidDate(date.value)) {
      return moment(date.value, "YYYY-MM-DD").format("YYYY-MM");
    } else if (isValidMonth(date.value)) {
      return date.value;
    } else {
      return null;
    }
  });

  const isDayView: ComputedRef<boolean> = computed(() => {
    return isValidDate(date.value);
  });

  const minMonth: ComputedRef<string> = computed(() => {
    return props.order?.validFrom ? moment(props.order.validFrom).format("YYYY-MM") : "";
  });

  const maxMonth: ComputedRef<string> = computed(() => {
    return props.order?.validTo ? moment(props.order.validTo).format("YYYY-MM") : "";
  });

  function edit(item: OrderPerDiemDateEntry) {
    router.app.$router.push({query: Object.assign({}, router.app.$route.query, {date: item.date})});
  }

  // Updates the date part of the current URL
  watch(() => state.yearMonth, (newYearMonth, oldYearMonth) => {
    // Only if the date has changed by either clicking or using a new URI update the actual route
    if (newYearMonth !== oldYearMonth && newYearMonth != currentMonth.value) {
      router.app.$router.push({query: Object.assign({}, router.app.$route.query, {date: newYearMonth})});
    }
  });

  watch(() => currentMonth.value, (newYearMonth, oldYearMonth) => {
    if (newYearMonth && oldYearMonth && newYearMonth != oldYearMonth) {
      loadPerDiems(newYearMonth);
    }
  });

return { __sfc: true,props, initialState, state, perDiemUpdateCallback, loadPerDiems, breadcrumbs, currentDateEntry, currentMonth, isDayView, minMonth, maxMonth, edit, MonthPicker, SwitchView, OrderPerDiemsDate, date, isValidDate }
}

})